const styles = (theme: Object) => ({
  root: {
    left: 0,
    backgroundColor: theme.palette.neutrals.background,
    color: theme.palette.neutrals.mainText,
    width: '100%',
    height: 50,
    display: 'flex',
    justifyContent: 'center',
    borderBottom: `1px solid ${theme.palette.neutrals.greyUI}`,
    zIndex: theme.zIndex.toolbar,
    alignItems: 'center',
  },
  withAppBar: {
    top: 60,
  },
  zoomIcons: {
    display: 'flex',
    alignItems: 'center',
    '&:hover': {
      cursor: 'pointer',
    },
    '&:nth-child(2)': {
      marginRight: 93,
    },
  },
  zoomIcon: {
    padding: 15,
    fontSize: 36,
    color: theme.palette.neutrals.mainText,
  },
  zoomIconDisabled: {
    color: theme.palette.neutrals.greyUI,
  },
  addFieldIcons: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 55,
    [theme.breakpoints.down('sm')]: {
      marginRight: 0,
    },
    outline: 'none',
    '& > *': {
      marginRight: 25,
      [theme.breakpoints.down('xs')]: {
        marginRight: 12,
      },
    },
  },
  followField: {
    position: 'fixed',
    zIndex: theme.zIndex.activeItem,
  },
  signedCount: {
    marginLeft: 49,
    color: theme.palette.neutrals.secondaryText,
  },
  signJumpButtons: {
    textTransform: 'capitalize',
    fontSize: 15,
  },
  chevronArrows: {
    margin: '0 6px',
    display: 'inline-flex',
    alignItems: 'center',
  },
});

export default styles;
